export default __webpack_public_path__ + "static/media/BFSSExp.59f0e4e6.md";